import { Platform } from 'react-native'

import Ionicons from '@expo/vector-icons/Ionicons'
import { WEB, ANDROID, IOS } from '$constants/Platforms.js'

const setStyleByPlatform = () => {
  switch (Platform.OS) {
    case WEB:
      return {
        marginLeft: 13,
        alignSelf: 'center',
        justifyContent: 'center',
      }
    case ANDROID:
      return {
        marginLeft: 5,
        alignSelf: 'center',
        justifyContent: 'center',
      }
    case IOS:
      return {
        marginLeft: 13,
        alignSelf: 'center',
        justifyContent: 'center',
      }
  }
}

const HeaderBackImage = ({ color }) => (
  <Ionicons
    name="arrow-back-outline"
    size={22}
    color={color}
    style={setStyleByPlatform()}
  />
)

export default HeaderBackImage
